import React, { useState, useEffect, useContext } from "react";
import {
  makeStyles,
  Card,
  CardContent,
  Typography,
  Button,
  Modal,
  TextField,
  Fade,
  Backdrop,
  Box,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  Avatar,
  Select,
  MenuItem,
  InputLabel,
  OutlinedInput,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import DoneIcon from "@material-ui/icons/Done";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import SendIcon from "@material-ui/icons/Send";
import CommentIcon from "@material-ui/icons/Comment";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AssignmentIcon from "@material-ui/icons/Assignment";
import LockIcon from "@material-ui/icons/Lock";
import PublicIcon from "@material-ui/icons/Public";
import PeopleIcon from "@material-ui/icons/People";
import SaveIcon from "@material-ui/icons/Save";
import VisibilityIcon from "@material-ui/icons/Visibility";
import PersonIcon from "@material-ui/icons/Person";
import moment from "moment";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    padding: 16,
    gap: 16,
  },
  card: {
    width: 280,
    height: 160,
    transition: "all 0.3s ease-in-out",
    "&:hover": { 
      transform: "translateY(-4px)",
      boxShadow: "0 8px 25px rgba(0,0,0,0.15)"
    },
    borderRadius: 16,
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    cursor: "pointer",
    color: "#333",
    position: "relative",
    border: "1px solid rgba(255,255,255,0.6)",
    overflow: "hidden",
    backdropFilter: "blur(20px)",
    backgroundColor: "rgba(255,255,255,0.05)", // Fundo ultra transparente
    opacity: 0.95,
  },
  cardHeader: {
    fontWeight: 600,
    fontSize: 18,
    display: "flex",
    alignItems: "center",
    marginBottom: 8,
    color: "#2c3e50",
  },
  cardEmoji: {
    fontSize: 22,
    marginRight: 10,
    color: "#3498db",
  },
  cardDescriptionPreview: {
    fontSize: 13,
    color: "#7f8c8d",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    lineHeight: 1.4,
    marginBottom: 12,
  },
  addButtonTop: {
    margin: 16,
    float: "right",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    "&:hover": { backgroundColor: theme.palette.primary.dark },
  },
  modalContent: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: 750,
    maxWidth: "95vw",
    maxHeight: "95vh",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 32,
    boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
    outline: "none",
    display: "flex",
    flexDirection: "column",
    gap: 20,
    overflowY: "auto",
  },
  modalDescription: {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    padding: "1rem",
    backgroundColor: "#f8f9fa",
    borderRadius: 12,
    marginTop: 8,
    marginBottom: 16,
    maxHeight: "300px",
    overflowY: "auto",
    border: "1px solid #e9ecef",
  },
  commentItem: {
    background: "#f1f1f1",
    padding: 6,
    borderRadius: 6,
    marginTop: 4,
  },
  buttonRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 16,
  },
  reminderModalContent: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: 350,
    transform: "translate(-50%, -50%)",
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 24,
    boxShadow: theme.shadows[5],
    outline: "none",
    textAlign: "center",
  },
  concluirIcon: {
    position: "absolute",
    bottom: 8,
    right: 8,
    color: "#4caf50",
    backgroundColor: "rgba(255,255,255,0.9)",
    borderRadius: "50%",
    padding: 4,
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#4caf50",
      color: "#fff",
      transform: "scale(1.1)",
    },
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
    paddingBottom: 16,
    borderBottom: "2px solid #f0f0f0",
  },
  modalTitle: {
    fontSize: 24,
    fontWeight: 600,
    color: "#333",
    marginLeft: 12,
  },
  formSection: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: "#555",
    marginBottom: 12,
    display: "flex",
    alignItems: "center",
  },
  visibilityCard: {
    border: "2px solid #e0e0e0",
    borderRadius: 12,
    padding: 16,
    margin: 8,
    minHeight: 110,
    transition: "all 0.3s ease",
    cursor: "pointer",
    flex: 1,
    "&:hover": {
      borderColor: "#1976d2",
      boxShadow: "0 4px 12px rgba(25,118,210,0.15)",
    },
  },
  selectedVisibility: {
    borderColor: "#1976d2",
    backgroundColor: "rgba(25,118,210,0.05)",
  },
  saveButton: {
    backgroundColor: "#1976d2",
    color: "#fff",
    borderRadius: 12,
    padding: "12px 24px",
    fontSize: 16,
    fontWeight: 600,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },
  userChip: {
    margin: 4,
  },
  commentSection: {
    marginTop: 20,
    marginBottom: 20,
  },
  commentsList: {
    maxHeight: 200,
    overflowY: "auto",
    backgroundColor: "#f8f9fa",
    borderRadius: 12,
    marginBottom: 16,
    border: "1px solid #e9ecef",
  },
  commentItem: {
    backgroundColor: "#fff",
    margin: "8px 12px",
    borderRadius: 8,
    border: "1px solid #e9ecef",
  },
  commentInputContainer: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  commentInput: {
    flex: 1,
  },
  sendButton: {
    backgroundColor: "#1976d2",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },
  modalActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 12,
    marginTop: 24,
    paddingTop: 16,
    borderTop: "1px solid #e9ecef",
  },
  actionButton: {
    borderRadius: 8,
    padding: "8px 16px",
    textTransform: "none",
    fontWeight: 600,
  },
  editButton: {
    backgroundColor: "#1976d2",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },
  deleteButton: {
    backgroundColor: "#f44336",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#d32f2f",
    },
  },
  exitButton: {
    backgroundColor: "#757575",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#616161",
    },
  },
}));

const getRandomPastelColor = () => {
  const lightColors = [
    'rgba(144, 238, 144, 0.15)', // Verde bem clarinho
    'rgba(173, 216, 230, 0.15)', // Azul bem clarinho  
    'rgba(221, 160, 221, 0.15)', // Roxo bem clarinho
    'rgba(255, 182, 193, 0.15)', // Rosa bem clarinho
    'rgba(152, 251, 152, 0.12)', // Verde menta clarinho
    'rgba(176, 224, 230, 0.12)', // Azul powder clarinho
    'rgba(230, 230, 250, 0.15)', // Lavanda clarinho
    'rgba(255, 228, 225, 0.12)', // Rosa misty clarinho
  ];
  return lightColors[Math.floor(Math.random() * lightColors.length)];
};

const ToDoList = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [tasks, setTasks] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [reminderTasks, setReminderTasks] = useState([]);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [companyUsers, setCompanyUsers] = useState([]);

  const [newTask, setNewTask] = useState({
    title: "",
    description: "",
    dueDate: "",
    comments: [],
    color: getRandomPastelColor(),
    visibility: "private", // private, public, selected_users
    assignedUsers: [], // array de IDs dos usuários selecionados
  });

  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const [newComment, setNewComment] = useState("");

  useEffect(() => {
    loadTasks();
    loadCompanyUsers();
  }, []);

  const loadTasks = async () => {
    try {
      // Primeiro tenta carregar do backend
      const { data } = await api.get("/todos");
      const todos = data.todos || data || [];
      setTasks(todos);
      
      const tomorrow = moment().add(1, "day").startOf("day");
      const reminders = todos.filter(
        (t) =>
          t.dueDate && moment(t.dueDate).startOf("day").isSame(tomorrow)
      );
      if (reminders.length) setReminderTasks(reminders);
    } catch (err) {
      // Fallback silencioso para localStorage
      const saved = localStorage.getItem("tasks");
      if (saved) {
        try {
          const loadedTasks = JSON.parse(saved);
          setTasks(loadedTasks);

          const tomorrow = moment().add(1, "day").startOf("day");
          const reminders = loadedTasks.filter(
            (t) =>
              t.dueDate && moment(t.dueDate).startOf("day").isSame(tomorrow)
          );
          if (reminders.length) setReminderTasks(reminders);
        } catch (parseErr) {
          // Se houver erro no parse, inicia com array vazio
          setTasks([]);
        }
      } else {
        setTasks([]);
      }
    } finally {
      setInitialLoadDone(true);
    }
  };

  const loadCompanyUsers = async () => {
    try {
      const { data } = await api.get("/todos/users");
      setCompanyUsers(data.users || data || []);
    } catch (err) {
      // Fallback silencioso - continua sem usuários
      setCompanyUsers([]);
    }
  };

  useEffect(() => {
    localStorage.setItem("tasks", JSON.stringify(tasks));
  }, [tasks]);

  const sortedTasks = [...tasks].sort((a, b) => {
    if (!a.dueDate && !b.dueDate) return 0;
    if (!a.dueDate) return 1;
    if (!b.dueDate) return -1;
    return new Date(a.dueDate) - new Date(b.dueDate);
  });

  const handleOpenCreate = () => {
    setNewTask({
      title: "",
      description: "",
      dueDate: "",
      comments: [],
      color: getRandomPastelColor(),
      visibility: "private",
      assignedUsers: [],
    });
    setIsEditing(true);
    setModalOpen(true);
    setSelectedTask(null);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedTask(null);
    setIsEditing(false);
    setDeleteConfirmOpen(false);
    setNewComment(""); // Limpar campo de comentário
  };

  const handleEditTask = () => {
    setNewTask({
      title: selectedTask.title,
      description: selectedTask.description,
      dueDate: selectedTask.dueDate,
      comments: selectedTask.comments || [],
      color: selectedTask.color,
      visibility: selectedTask.visibility || "private",
      assignedUsers: selectedTask.assignedUsers || [],
    });
    setIsEditing(true);
  };

  const handleCardClick = (task) => {
    setSelectedTask(task);
    setIsEditing(false);
    setModalOpen(true);
  };

  const handleSaveTask = async () => {
    if (!newTask.title.trim()) return;
    
    const now = new Date().toISOString();
    const taskData = {
      ...newTask,
      createdAt: selectedTask?.createdAt || now,
      updatedAt: now,
      createdBy: user.id,
      companyId: user.companyId,
    };

    try {
      if (selectedTask) {
        // Atualizar tarefa existente
        await api.put(`/todos/${selectedTask.id}`, taskData);
        setTasks(
          tasks.map((t) =>
            t.createdAt === selectedTask.createdAt ? { ...taskData, id: selectedTask.id } : t
          )
        );
      } else {
        // Criar nova tarefa
        const { data } = await api.post("/todos", taskData);
        setTasks([...tasks, data]);
      }
    } catch (err) {
      // Fallback silencioso para localStorage
      if (selectedTask) {
        setTasks(
          tasks.map((t) =>
            t.createdAt === selectedTask.createdAt ? taskData : t
          )
        );
      } else {
        setTasks([...tasks, taskData]);
      }
    }
    
    handleCloseModal();
  };

  const handleAddComment = async () => {
    if (!newComment.trim()) return;
    
    const comment = {
      text: newComment.trim(),
      author: user.name,
      createdAt: new Date().toISOString(),
    };

    try {
      // Salvar no banco de dados usando a rota correta de comentários
      if (selectedTask.id) {
        const response = await api.post(`/todos/${selectedTask.id}/comments`, {
          comment: newComment.trim()
        });
        
        // Atualizar com os dados retornados do backend
        const updatedTask = response.data;
        setTasks(
          tasks.map((t) =>
            t.createdAt === selectedTask.createdAt ? updatedTask : t
          )
        );
        setSelectedTask(updatedTask);
        setNewComment(""); // Limpar campo de comentário
      }
    } catch (err) {
      console.error("Erro ao salvar comentário:", err);
      // Em caso de erro, recarrega a tarefa para sincronizar com o backend
      if (selectedTask.id) {
        try {
          const response = await api.get(`/todos/${selectedTask.id}`);
          const updatedTask = response.data;
          setTasks(
            tasks.map((t) =>
              t.createdAt === selectedTask.createdAt ? updatedTask : t
            )
          );
          setSelectedTask(updatedTask);
        } catch (reloadErr) {
          console.error("Erro ao recarregar tarefa:", reloadErr);
        }
      }
    }
  };

  const handleDeleteClick = () => setDeleteConfirmOpen(true);
  const confirmDelete = async () => {
    try {
      if (selectedTask.id) {
        await api.delete(`/todos/${selectedTask.id}`);
      }
      // Remove da lista apenas se a operação foi bem-sucedida
      setTasks(tasks.filter((t) => t.createdAt !== selectedTask.createdAt));
      handleCloseModal();
    } catch (err) {
      console.error("Erro ao deletar tarefa:", err);
      // Se houver erro, recarrega a lista para sincronizar com o backend
      loadTasks();
      handleCloseModal();
    }
  };

  const handleConclude = async (task) => {
    try {
      if (task.id) {
        await api.delete(`/todos/${task.id}`);
      }
      // Remove da lista apenas se a operação foi bem-sucedida
      setTasks(tasks.filter((t) => t.createdAt !== task.createdAt));
    } catch (err) {
      console.error("Erro ao concluir tarefa:", err);
      // Se houver erro, recarrega a lista para sincronizar com o backend
      loadTasks();
    }
  };

  const handleVisibilityChange = (visibility) => {
    setNewTask({ ...newTask, visibility, assignedUsers: [] });
  };

  const handleUserSelection = (userId) => {
    const updatedUsers = newTask.assignedUsers.includes(userId)
      ? newTask.assignedUsers.filter(id => id !== userId)
      : [...newTask.assignedUsers, userId];
    
    setNewTask({ ...newTask, assignedUsers: updatedUsers });
  };

  const getVisibilityIcon = (visibility) => {
    switch (visibility) {
      case 'private': return <LockIcon />;
      case 'public': return <PublicIcon />;
      case 'selected_users': return <PeopleIcon />;
      default: return <LockIcon />;
    }
  };

  const getVisibilityText = (visibility) => {
    switch (visibility) {
      case 'private': return 'Apenas eu posso ver';
      case 'public': return 'Todos da empresa podem ver';
      case 'selected_users': return 'Usuários selecionados podem ver';
      default: return 'Apenas eu posso ver';
    }
  };

  const isTaskVisible = (task) => {
    if (!task.visibility) return true; // Tarefas antigas sem campo visibility
    
    switch (task.visibility) {
      case 'private':
        return task.createdBy === user.id;
      case 'public':
        return true;
      case 'selected_users':
        return task.createdBy === user.id || (task.assignedUsers && task.assignedUsers.includes(user.id));
      default:
        return true;
    }
  };

  return (
    <div>
      <Box display="flex" justifyContent="flex-end">
        <Button
          className={classes.addButtonTop}
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenCreate}
        >
          Adicionar Tarefa
        </Button>
      </Box>

      <div className={classes.container}>
        {sortedTasks.filter(isTaskVisible).map((task, i) => (
          <Card
            key={i}
            className={classes.card}
            style={{ 
              backgroundColor: task.color || 'rgba(255,255,255,0.08)' // Usa a cor já transparente ou fallback ultra transparente
            }}
            onClick={() => handleCardClick(task)}
          >
            <CardContent style={{ padding: 20, height: "100%", display: "flex", flexDirection: "column" }}>
              <Box className={classes.cardHeader}>
                <AssignmentIcon className={classes.cardEmoji} />
                <Box component="span" flex={1}>{task.title}</Box>
                {task.visibility && (
                  <Box ml={1} display="flex" alignItems="center">
                    {getVisibilityIcon(task.visibility)}
                  </Box>
                )}
              </Box>
              {task.description && (
                <Typography className={classes.cardDescriptionPreview}>
                  {task.description}
                </Typography>
              )}
              <Box mt="auto">
                {task.dueDate && (
                  <Typography
                    variant="body2"
                    style={{ color: "#e74c3c", fontWeight: 600, marginBottom: 12, fontSize: 12 }}
                  >
                    📅 Prazo: {moment(task.dueDate).format("DD/MM/YYYY")}
                  </Typography>
                )}
              </Box>
              <IconButton
                className={classes.concluirIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  handleConclude(task);
                }}
                size="small"
              >
                <CheckCircleIcon />
              </IconButton>
            </CardContent>
          </Card>
        ))}
      </div>

      <Modal open={modalOpen} onClose={handleCloseModal} BackdropComponent={Backdrop}>
        <Fade in={modalOpen}>
          <div className={classes.modalContent}>
            {isEditing ? (
              <>
                <div className={classes.modalHeader}>
                  <AssignmentIcon style={{ fontSize: 28, color: "#1976d2" }} />
                  <Typography className={classes.modalTitle}>
                    {selectedTask ? "Editar Tarefa" : "Nova Tarefa"}
                  </Typography>
                </div>

                <div className={classes.formSection}>
                  <TextField
                    label="Título da Tarefa"
                    fullWidth
                    variant="outlined"
                    value={newTask.title}
                    onChange={(e) =>
                      setNewTask({ ...newTask, title: e.target.value })
                    }
                    style={{ marginBottom: 16 }}
                  />
                  
                  <TextField
                    label="Descrição detalhada"
                    multiline
                    rows={4}
                    fullWidth
                    variant="outlined"
                    value={newTask.description}
                    onChange={(e) =>
                      setNewTask({ ...newTask, description: e.target.value })
                    }
                    style={{ marginBottom: 16 }}
                  />
                  
                  <TextField
                    label="Data de Vencimento"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    variant="outlined"
                    value={newTask.dueDate}
                    onChange={(e) =>
                      setNewTask({ ...newTask, dueDate: e.target.value })
                    }
                    style={{ marginBottom: 20 }}
                  />
                </div>

                <div className={classes.formSection}>
                  <Typography className={classes.sectionTitle}>
                    <VisibilityIcon style={{ marginRight: 8, color: "#1976d2" }} />
                    Quem pode ver esta tarefa?
                  </Typography>
                  
                  <Box display="flex" flexDirection="row" flexWrap="wrap" gap={1}>
                    <Box 
                      className={`${classes.visibilityCard} ${
                        newTask.visibility === 'private' ? classes.selectedVisibility : ''
                      }`}
                      onClick={() => handleVisibilityChange('private')}
                    >
                      <Box display="flex" alignItems="center" mb={1}>
                        <LockIcon style={{ marginRight: 12, color: "#ff9800" }} />
                        <Typography variant="h6" style={{ fontWeight: 600 }}>
                          Apenas eu
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="textSecondary">
                        Somente você poderá visualizar esta tarefa
                      </Typography>
                    </Box>

                    <Box 
                      className={`${classes.visibilityCard} ${
                        newTask.visibility === 'public' ? classes.selectedVisibility : ''
                      }`}
                      onClick={() => handleVisibilityChange('public')}
                    >
                      <Box display="flex" alignItems="center" mb={1}>
                        <PublicIcon style={{ marginRight: 12, color: "#4caf50" }} />
                        <Typography variant="h6" style={{ fontWeight: 600 }}>
                          Todos da empresa
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="textSecondary">
                        Todos os usuários da empresa poderão ver esta tarefa
                      </Typography>
                    </Box>

                    {user.profile === "admin" && (
                      <Box 
                        className={`${classes.visibilityCard} ${
                          newTask.visibility === 'selected_users' ? classes.selectedVisibility : ''
                        }`}
                        onClick={() => handleVisibilityChange('selected_users')}
                      >
                        <Box display="flex" alignItems="center" mb={1}>
                          <PeopleIcon style={{ marginRight: 12, color: "#2196f3" }} />
                          <Typography variant="h6" style={{ fontWeight: 600 }}>
                            Usuários específicos
                          </Typography>
                        </Box>
                        <Typography variant="body2" color="textSecondary">
                          Escolha quais usuários poderão visualizar esta tarefa
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {newTask.visibility === 'selected_users' && user.profile === "admin" && (
                    <Box mt={3}>
                      <Typography className={classes.sectionTitle}>
                        <PersonIcon style={{ marginRight: 8, color: "#1976d2" }} />
                        Selecionar Usuários
                      </Typography>
                      <Box display="flex" flexWrap="wrap" gap={1} mt={2}>
                        {companyUsers.map(companyUser => (
                          <Chip
                            key={companyUser.id}
                            avatar={<Avatar>{companyUser.name.charAt(0)}</Avatar>}
                            label={companyUser.name}
                            onClick={() => handleUserSelection(companyUser.id)}
                            color={newTask.assignedUsers.includes(companyUser.id) ? "primary" : "default"}
                            variant={newTask.assignedUsers.includes(companyUser.id) ? "default" : "outlined"}
                            className={classes.userChip}
                          />
                        ))}
                      </Box>
                    </Box>
                  )}
                </div>

                <Box display="flex" justifyContent="flex-end" mt={3}>
                  <Button
                    variant="contained"
                    className={classes.saveButton}
                    startIcon={<SaveIcon />}
                    onClick={handleSaveTask}
                    size="large"
                  >
                    {selectedTask ? "Atualizar Tarefa" : "Criar Tarefa"}
                  </Button>
                </Box>
              </>
            ) : selectedTask && (
              <>
                <div className={classes.modalHeader}>
                  <AssignmentIcon style={{ fontSize: 28, color: "#1976d2" }} />
                  <Typography className={classes.modalTitle}>
                    {selectedTask.title}
                  </Typography>
                </div>

                <div className={classes.formSection}>
                  <Typography className={classes.modalDescription}>
                    {selectedTask.description}
                  </Typography>
                  
                  <Box display="flex" gap={3} mt={2} mb={2}>
                    <Typography variant="body2" style={{ color: "#666" }}>
                      📅 Criado: {moment(selectedTask.createdAt).format("DD/MM/YYYY HH:mm")}
                    </Typography>
                    <Typography variant="body2" style={{ color: "#666" }}>
                      🔄 Atualizado: {moment(selectedTask.updatedAt).format("DD/MM/YYYY HH:mm")}
                    </Typography>
                  </Box>
                  
                  {selectedTask.dueDate && (
                    <Typography variant="body2" style={{ color: "#e74c3c", fontWeight: 600 }}>
                      ⏰ Prazo: {moment(selectedTask.dueDate).format("DD/MM/YYYY")}
                    </Typography>
                  )}

                  {selectedTask.visibility && (
                    <Box mt={2} display="flex" alignItems="center">
                      <Typography variant="body2" style={{ color: "#666", marginRight: 8 }}>
                        👁️ Visibilidade:
                      </Typography>
                      {getVisibilityIcon(selectedTask.visibility)}
                      <Typography variant="body2" style={{ color: "#666", marginLeft: 4 }}>
                        {getVisibilityText(selectedTask.visibility)}
                      </Typography>
                    </Box>
                  )}
                </div>

                <div className={classes.commentSection}>
                  <Typography variant="h6" style={{ marginBottom: 16, color: "#555", display: "flex", alignItems: "center" }}>
                    <CommentIcon style={{ marginRight: 8, color: "#1976d2" }} />
                    Comentários
                  </Typography>
                  
                  {selectedTask.comments && selectedTask.comments.length > 0 && (
                    <List className={classes.commentsList}>
                      {selectedTask.comments.map((comment, i) => (
                        <ListItem key={i} className={classes.commentItem}>
                          <ListItemText
                            primary={typeof comment === 'string' ? comment : comment.text}
                            secondary={
                              typeof comment === 'object' && comment.author && comment.createdAt
                                ? `${comment.author} - ${moment(comment.createdAt).format("DD/MM/YYYY HH:mm")}`
                                : null
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  )}
                  
                  <div className={classes.commentInputContainer}>
                    <TextField
                      label="Adicionar comentário"
                      variant="outlined"
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          handleAddComment();
                        }
                      }}
                      className={classes.commentInput}
                      multiline
                      maxRows={3}
                    />
                    <IconButton
                      className={classes.sendButton}
                      onClick={handleAddComment}
                      disabled={!newComment.trim()}
                    >
                      <SendIcon />
                    </IconButton>
                  </div>
                </div>

                <div className={classes.modalActions}>
                  <Button
                    variant="contained"
                    startIcon={<EditIcon />}
                    onClick={handleEditTask}
                    className={`${classes.actionButton} ${classes.editButton}`}
                  >
                    Editar Tarefas
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<DeleteIcon />}
                    onClick={handleDeleteClick}
                    className={`${classes.actionButton} ${classes.deleteButton}`}
                  >
                    Excluir Tarefas
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<ExitToAppIcon />}
                    onClick={handleCloseModal}
                    className={`${classes.actionButton} ${classes.exitButton}`}
                  >
                    Sair
                  </Button>
                </div>
              </>
            )}
          </div>
        </Fade>
      </Modal>

      <Modal open={deleteConfirmOpen} onClose={() => setDeleteConfirmOpen(false)} BackdropComponent={Backdrop}>
        <Fade in={deleteConfirmOpen}>
          <div className={classes.modalContent}>
            <Typography variant="h6" align="center">
              Confirmar exclusão
            </Typography>
            <Typography align="center">
              Tem certeza que deseja excluir esta tarefa?
            </Typography>
            <Box display="flex" justifyContent="space-between" marginTop={2}>
              <Button variant="contained" color="secondary" onClick={confirmDelete}>
                Sim
              </Button>
              <Button variant="outlined" onClick={() => setDeleteConfirmOpen(false)}>
                Não
              </Button>
            </Box>
          </div>
        </Fade>
      </Modal>

      <Modal open={reminderTasks.length > 0} onClose={() => setReminderTasks([])} BackdropComponent={Backdrop}>
        <Fade in={reminderTasks.length > 0}>
          <div className={classes.reminderModalContent}>
            <Typography variant="h6" style={{ color: "orange" }}>
              ⚠️ Tarefas com prazo amanhã:
            </Typography>
            {reminderTasks.map((t, i) => (
              <Typography key={i}>
                <strong>{t.title}</strong>
              </Typography>
            ))}
            <Button onClick={() => setReminderTasks([])} variant="contained" color="primary">
              Entendi
            </Button>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default ToDoList;
